/**
 * Translations for the new-account hatching flow:
 *   - HatchingEgg bubble
 *   - HomePage gate copy
 *   - legacy OnboardingQuizPage fallback
 *   - OnboardingHatchPage
 *
 * Spec: doc/FEATURES.md PR-1.
 */
const onboarding = {
  zh: {
    'hatch.egg.aria': '会动的蛋，戳一戳',
    'hatch.egg.bubble': '戳戳我！',

    'onboarding.gate.title': '蛋在动！里面的小伙伴在敲门…',
    'onboarding.gate.subtitle': '戳满 3 下，直接孵化你的第一只小宠物 🐣',
    'onboarding.gate.progress': '已戳 {current} / {total}',

    'onboarding.quiz.title': '小小热身',
    'onboarding.quiz.progress': '第 {current} / {total} 题',
    'onboarding.quiz.helper': '答完三道题就能孵化你的小伙伴啦～',
    'onboarding.quiz.submit': '提交答案',
    'onboarding.quiz.correct': '✨ 答对啦！',
    'onboarding.quiz.wrong': '差一点点！',
    'onboarding.quiz.error.load': '加载题目失败',
    'onboarding.quiz.error.submit': '提交答案失败',

    'onboarding.hatch.cracking': '蛋开始裂啦…',
    'onboarding.hatch.reveal': '✨ 一道金光！',
    'onboarding.hatch.born': '小毛宝宝出来啦！',
    'onboarding.hatch.namePrompt': '快给 TA 起个名字吧～',
    'onboarding.hatch.placeholder': '例如：小毛',
    'onboarding.hatch.confirm': '就叫 TA 这个名字！',
    'onboarding.hatch.skip': '稍后再说',
    'onboarding.hatch.error.nickname': '名字至少 1 个字',
    'onboarding.hatch.error.complete': '出错了，请重试',
  } as Record<string, string>,
  en: {
    'hatch.egg.aria': 'Wiggling egg — tap me',
    'hatch.egg.bubble': 'Poke me!',

    'onboarding.gate.title': "The egg is moving — someone is tapping back!",
    'onboarding.gate.subtitle': 'Tap 3 times to hatch your first pet right away 🐣',
    'onboarding.gate.progress': 'Tapped {current} / {total}',

    'onboarding.quiz.title': 'Quick warm-up',
    'onboarding.quiz.progress': 'Question {current} / {total}',
    'onboarding.quiz.helper': 'Three questions and your buddy will hatch~',
    'onboarding.quiz.submit': 'Submit',
    'onboarding.quiz.correct': '✨ Correct!',
    'onboarding.quiz.wrong': "So close — let's keep going!",
    'onboarding.quiz.error.load': 'Failed to load question',
    'onboarding.quiz.error.submit': 'Failed to submit',

    'onboarding.hatch.cracking': 'The egg is cracking…',
    'onboarding.hatch.reveal': '✨ A burst of light!',
    'onboarding.hatch.born': 'Your little hamster is here!',
    'onboarding.hatch.namePrompt': "Give them a name~",
    'onboarding.hatch.placeholder': 'e.g. Little Mochi',
    'onboarding.hatch.confirm': "Yes, that's the name!",
    'onboarding.hatch.skip': 'Later',
    'onboarding.hatch.error.nickname': 'Name needs at least 1 character',
    'onboarding.hatch.error.complete': 'Something went wrong, please try again',
  } as Record<string, string>,
};
export default onboarding;
